import 'es6-promise/auto'
import axios from 'axios'
import { isNull, debounce } from '~/misc/Utils'
import Swiper from 'swiper/bundle'
import 'swiper/css/bundle'

class App {
    constructor() {
        this.getDom()
        this.bindEvents()
        this.resize()
    }

    getDom() {
        this.dom = {
            addButton: document.querySelectorAll('.js-add-cross-sell'),
            swiperEl: document.querySelector('.swiper'),
            scrollbar: document.querySelector('.swiper-scrollbar'),
        }
    }

    bindEvents() {
        if (!isNull(this.dom.addButton)) {
            this.dom.addButton.forEach((button) => {
                button.addEventListener('click', this.handleAddToCart.bind(this))
            })
        }

        window.addEventListener(
            'resize',
            debounce(() => {
                this.resize()
            }, 150),
            false
        )
    }

    resize() {
        if (isNull(this.dom.swiperEl)) {
            return
        }

        new Swiper(this.dom.swiperEl, {
            slidesPerView: 1,
            spaceBetween: 24,
            loop: false,
            breakpoints: {
                320: {
                    slidesPerView: 1.5,
                    spaceBetween: 12,
                },
                560: {
                    slidesPerView: 1.5,
                    spaceBetween: 12,
                },
                768: {
                    slidesPerView: 1.5,
                    spaceBetween: 12,
                },
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 24,
                },
            },
            scrollbar: {
                el: this.dom.scrollbar,
                draggable: true,
                dragSize: 'auto',
            },
        })
    }

    async handleAddToCart(event) {
        event.preventDefault()
        const productId = event.currentTarget.dataset.productId
        const quantity = 1

        event.currentTarget.classList.add('is-loading')

        await axios
            .post('/cart/add.js', {
                items: [
                    {
                        id: productId,
                        quantity: parseInt(quantity, 10),
                    },
                ],
            })
            .then((response) => {
                window.location.reload()
            })
            .catch((error) => {
                console.error('Error adding product to cart:', error)
            })
            .finally(() => {
                event.currentTarget.classList.remove('is-loading')
            })
    }
}

new App()
